$(document).ready(function() {
  	var url = window.location.href;
    var text = '&form_type=customer';
    var text2 = 'contact%5Berror%5D=&';
    
    if(url.indexOf(text2) != -1){
      
    } else {
      if(url.indexOf(text) != -1){
        $('.form-message--error').show();
      } else {
        $('.form-message--error').hide();
      }
    }
  });
  $('.newsletter__submit').click(function(e) {
    
    e.preventDefault();
    
    var email = $('#ContactFooter-email').val();
    
    $('#error_email').val(email);
    
    $('#ContactFooter').submit();
  });